export default __webpack_public_path__ + "static/media/WStore_Partners.a934c47b.png";